
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class SectionTitle extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
  }
